<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="info-modal">
        <div class="info-modal__icon">
          <slot name="icon" />
        </div>
        <slot name="title" />
        <div class="info-modal__content">
          <slot name="content" />
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import Popup from '@/components/cards/popup/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const retryPayment = () => {
  store.actions.setComponent('review-payment')
}
</script>
